import {SvgIcon} from './SvgIcon'

export const FolderIcon: SvgIcon = ({
  width = 16,
  height = 16,
  fillColor = 'currentColor',
  classes = '',
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    viewBox="0 -960 960 960"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160H160Zm0-80h640v-400H447l-80-80H160v480Zm0 0v-480 480Z" />
  </svg>
)

export const SharedFolderIcon: SvgIcon = ({
  width = 24,
  height = 24,
  fillColor = 'currentColor',
  classes = '',
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <g>
      <path d="M19,2H5C3.9,2,3,2.9,3,4v13h18V4C21,2.9,20.1,2,19,2z M9.5,7C10.33,7,11,7.67,11,8.5c0,0.83-0.67,1.5-1.5,1.5 S8,9.33,8,8.5C8,7.67,8.67,7,9.5,7z M13,14H6v-1.35C6,11.55,8.34,11,9.5,11s3.5,0.55,3.5,1.65V14z M14.5,7C15.33,7,16,7.67,16,8.5 c0,0.83-0.67,1.5-1.5,1.5S13,9.33,13,8.5C13,7.67,13.67,7,14.5,7z M18,14h-4v-1.35c0-0.62-0.3-1.12-0.75-1.5 c0.46-0.1,0.9-0.15,1.25-0.15c1.16,0,3.5,0.55,3.5,1.65V14z"></path>
      <path d="M3,20c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-2H3V20z M18,19c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S17.45,19,18,19z"></path>
    </g>
  </svg>
)

export const GoogleDriveFolderIcon: SvgIcon = ({
  width = 24,
  height = 24,
  fillColor = 'currentColor',
  classes = '',
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path d="M9.05 15H15q.275 0 .5-.137.225-.138.35-.363l1.1-1.9q.125-.225.1-.5-.025-.275-.15-.5l-2.95-5.1q-.125-.225-.35-.363Q13.375 6 13.1 6h-2.2q-.275 0-.5.137-.225.138-.35.363L7.1 11.6q-.125.225-.125.5t.125.5l1.05 1.9q.125.25.375.375T9.05 15Zm1.2-3L12 9l1.75 3ZM3 17V4q0-.825.587-1.413Q4.175 2 5 2h14q.825 0 1.413.587Q21 3.175 21 4v13Zm2 5q-.825 0-1.413-.587Q3 20.825 3 20v-1h18v1q0 .825-.587 1.413Q19.825 22 19 22Z" />
  </svg>
)

export const MicrosoftSharedIcon: SvgIcon = ({
  width = 24,
  height = 24,
  fillColor = 'currentColor',
  classes = '',
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path d="M16 11c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3Zm-8 0c1.657 0 3-1.343 3-3S9.657 5 8 5 5 6.343 5 8s1.343 3 3 3Zm0 2c-2.761 0-7 1.343-7 3.5V20h14v-3.5C15 14.343 10.761 13 8 13Zm8 0c-.337 0-.68.02-1.02.058 1.737.646 3.02 1.844 3.02 3.442V20h6v-3.5c0-2.157-4.239-3.5-8-3.5Z" />
  </svg>
)

export const MicrosoftPersonalFolderIcon: SvgIcon = ({
  width = 24,
  height = 24,
  fillColor = 'currentColor',
  classes = '',
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={classes}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path
      d="M3.5 6.25V8H8.12868C8.32759 8 8.51836 7.92098 8.65901 7.78033L10.1893 6.25L8.65901 4.71967C8.51836 4.57902 8.32759 4.5 8.12868 4.5H5.25C4.2835 4.5 3.5 5.2835 3.5 6.25ZM2 6.25C2 4.45507 3.45507 3 5.25 3H8.12868C8.72542 3 9.29771 3.23705 9.71967 3.65901L11.5607 5.5H18.75C20.5449 5.5 22 6.95507 22 8.75V17.75C22 19.5449 20.5449 21 18.75 21H5.25C3.45507 21 2 19.5449 2 17.75V6.25ZM3.5 9.5V17.75C3.5 18.7165 4.2835 19.5 5.25 19.5H18.75C19.7165 19.5 20.5 18.7165 20.5 17.75V8.75C20.5 7.7835 19.7165 7 18.75 7H11.5607L9.71967 8.84099C9.29771 9.26295 8.72542 9.5 8.12868 9.5H3.5Z"
      fill={fillColor}
    />
  </svg>
)

export const GlobeIcon2: SvgIcon = ({
  width = 18,
  height = 18,
  strokeColor = '#F7C839',
  strokeWidth = 1.5,
  fillColor = '#000000',
  classes = '',
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    viewBox="0 0 18 19"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path
      d="M14.4375 9.5C14.4375 12.503 12.003 14.9375 9 14.9375C5.99695 14.9375 3.5625 12.503 3.5625 9.5C3.5625 6.49695 5.99695 4.0625 9 4.0625C12.003 4.0625 14.4375 6.49695 14.4375 9.5Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4375 9.5C11.4375 12.875 9.93198 14.9375 9 14.9375C8.06802 14.9375 6.5625 12.875 6.5625 9.5C6.5625 6.125 8.06802 4.0625 9 4.0625C9.93198 4.0625 11.4375 6.125 11.4375 9.5Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 9.5H14.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const HealthIcon: SvgIcon = ({
  width = 18,
  height = 18,
  strokeColor = '#D4A0FF',
  fillColor = '#000000',
  classes = '',
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 19"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path
      d="M3 5.17026C3 3.79907 4.11157 2.6875 5.48276 2.6875H12.5172C13.8884 2.6875 15 3.79907 15 5.17026V12.2047C15 13.5759 13.8884 14.6875 12.5172 14.6875H5.48276C4.11157 14.6875 3 13.5759 3 12.2047V5.17026Z"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0361 5.17188H7.96713V7.65463H5.48438V9.7236H7.96713V12.2064H10.0361V9.7236H12.5189V7.65463H10.0361V5.17188Z"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CreditCardIcon: SvgIcon = ({
  width = 18,
  height = 18,
  strokeColor = '#D750FB',
  strokeWidth = 1.5,
  fillColor = '#000000',
  classes = '',
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 19"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path
      d="M3.5625 6.3125C3.5625 5.48407 4.23407 4.8125 5.0625 4.8125H12.9375C13.7659 4.8125 14.4375 5.48407 14.4375 6.3125V12.6875C14.4375 13.5159 13.7659 14.1875 12.9375 14.1875H5.0625C4.23407 14.1875 3.5625 13.5159 3.5625 12.6875V6.3125Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 8.1875H14.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.8125 11.1875H7.6875"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8125 11.1875H12.1875"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PersonIcon: SvgIcon = ({
  width = 18,
  height = 18,
  strokeWidth = 1.5,
  strokeColor = '#8A8DFC',
  fillColor = '#000000',
  classes = '',
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    viewBox="0 0 18 19"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path
      d="M11.4375 6.5C11.4375 7.84619 10.3462 8.9375 9 8.9375C7.65381 8.9375 6.5625 7.84619 6.5625 6.5C6.5625 5.15381 7.65381 4.0625 9 4.0625C10.3462 4.0625 11.4375 5.15381 11.4375 6.5Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.13445 14.9375H12.8632C13.7196 14.9375 14.3793 14.2011 13.9794 13.4438C13.3911 12.3298 12.0498 11 8.99882 11C5.94783 11 4.60657 12.3298 4.01825 13.4438C3.61829 14.2011 4.27801 14.9375 5.13445 14.9375Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const UndoIcon: SvgIcon = ({
  width = 18,
  height = 18,
  strokeColor = '#AF50FF',
  strokeWidth = 1.5,
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path
      d="M6.9375 3.5625L3.5625 6.75L6.9375 9.9375"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.125 6.75H11.4375C13.0944 6.75 14.4375 8.09315 14.4375 9.75V14.4375"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ChevronIconBottom: SvgIcon = ({
  width = 18,
  height = 19,
  strokeColor = '#F7C839',
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path
      d="M11.4375 8.5625L9 11.1875L6.5625 8.5625"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const EyeIconLg: SvgIcon = ({
  width = 18,
  height = 19,
  strokeColor = '#F7C839',
  strokeWidth = 1.5,
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path
      d="M14.8125 9.5C14.8125 10.25 13.4095 14.1875 9 14.1875C4.59052 14.1875 3.1875 10.25 3.1875 9.5C3.1875 8.75 4.59052 4.8125 9 4.8125C13.4095 4.8125 14.8125 8.75 14.8125 9.5Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6875 9.5C10.6875 10.432 9.93198 11.1875 9 11.1875C8.06802 11.1875 7.3125 10.432 7.3125 9.5C7.3125 8.56802 8.06802 7.8125 9 7.8125C9.93198 7.8125 10.6875 8.56802 10.6875 9.5Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FullArrowIcon: SvgIcon = ({
  width = 25,
  height = 25,
  strokeColor = 'text-dope-purple-50',
  strokeWidth = 1.5,
  classes,
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path
      d="M10.7227 7.25L5.22266 12.5L10.7227 17.75"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7227 12.5H5.47266"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ShieldIcon: SvgIcon = ({
  width = 19,
  height = 18,
  strokeColor = 'stroke-dope-red-200',
  fillColor = 'fill-dope-red-200',
  classes,
  ariaLabel,
  datacy,
  id,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    data-cy={datacy}
    id={id}
    onClick={onClick}
    focusable="false"
  >
    <path
      d="M9.4984 3.5625L4.0609 6C4.0609 6 3.4984 14.4375 9.4984 14.4375C15.4984 14.4375 14.9359 6 14.9359 6L9.4984 3.5625Z"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`${strokeColor} stroke-current`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 5.8125C9.91421 5.8125 10.25 6.23223 10.25 6.75V8.625C10.25 9.14277 9.91421 9.5625 9.5 9.5625C9.08579 9.5625 8.75 9.14277 8.75 8.625V6.75C8.75 6.23223 9.08579 5.8125 9.5 5.8125Z"
      className={`${fillColor} fill-current`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 11.625C8.75 11.2108 9.08579 10.875 9.5 10.875C9.91421 10.875 10.25 11.2108 10.25 11.625C10.25 12.0392 9.91421 12.375 9.5 12.375C9.08579 12.375 8.75 12.0392 8.75 11.625Z"
      className={`${fillColor} fill-current`}
    />
  </svg>
)

// ProviderFolderIcon has been moved to the CASB feature layer
